import { useState } from "react";
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Textarea } from "../../components/ui/textarea";
import { Label } from "../../components/ui/label";
import { PenTool } from "lucide-react";

import { useDispatch } from "react-redux";
import { UpdateAppointmentNotesAPI } from "./appointmentAPI";
import { setWorkNotes } from "./appointmentSlice";
import { useIntl } from "react-intl";

function OverviewTab({
  appointmentId,
  workNotes,
  signature,
  customerSignatureName,
  customerSignatureEmail,
  signatureTimestamp,
}) {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [saving, setSaving] = useState(false);

  async function handleSaveNotes() {
    if (!appointmentId) return;
    setSaving(true);
    try {
      const success = await dispatch(
        UpdateAppointmentNotesAPI(appointmentId, workNotes)
      );
      if (success) {
        // toast.success(intl.formatMessage({ id: "Overview.NotesSaved" }));
      }
    } catch {
      // toast.error(intl.formatMessage({ id: "Overview.SaveError" }));
    } finally {
      setSaving(false);
    }
  }

  return (
    <>
      <Card>
        <CardHeader className="!p-4 !pb-0">
          <CardTitle className="flex items-center gap-2 text-base">
            <PenTool className="text-green-600 w-4 h-4" />
            {intl.formatMessage({ id: "Overview.WorkNotes" })}
          </CardTitle>
        </CardHeader>
        <CardContent className="!p-4 space-y-4">
          <Textarea
            value={workNotes}
            onChange={(e) => dispatch(setWorkNotes(e.target.value))}
            placeholder={intl.formatMessage({
              id: "Overview.WorkNotes.Placeholder",
            })}
            className="min-h-32"
            disabled={saving}
          />
          <Button
            onClick={handleSaveNotes}
            disabled={saving}
            className="w-full"
          >
            {saving
              ? intl.formatMessage({ id: "Overview.Saving" })
              : intl.formatMessage({ id: "Overview.SaveNotes" })}
          </Button>
        </CardContent>
      </Card>

      {signature && (
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-base">
              <PenTool className="text-green-600 w-4 h-4" />
              {intl.formatMessage({ id: "Overview.CustomerSignature" })}
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="grid grid-cols-1 gap-4">
              <div>
                <Label className="text-sm font-semibold">
                  {intl.formatMessage({ id: "Overview.CustomerName" })}
                </Label>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  {customerSignatureName ||
                    intl.formatMessage({ id: "Common.NotProvided" })}
                </p>
              </div>
              {customerSignatureEmail && (
                <div>
                  <Label className="text-sm font-semibold">
                    {intl.formatMessage({ id: "Overview.Email" })}
                  </Label>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    {customerSignatureEmail}
                  </p>
                </div>
              )}
              <div>
                <Label className="text-sm font-semibold">
                  {intl.formatMessage({ id: "Overview.SignedAt" })}
                </Label>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  {signatureTimestamp
                    ? new Intl.DateTimeFormat(intl.locale, {
                        dateStyle: "medium",
                        timeStyle: "short",
                      }).format(new Date(signatureTimestamp))
                    : intl.formatMessage({ id: "Common.NotProvided" })}
                </p>
              </div>
              <div>
                <Label className="text-sm font-semibold">
                  {intl.formatMessage({ id: "Overview.DigitalSignature" })}
                </Label>
                <div className="border rounded-lg p-2 bg-white dark:bg-gray-50">
                  <img
                    src={signature}
                    alt={intl.formatMessage({
                      id: "Overview.CustomerSignature",
                    })}
                    className="max-w-full h-auto"
                    style={{ maxHeight: 150 }}
                  />
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      )}
    </>
  );
}

export default OverviewTab;
